export default "__VITE_ASSET__BRGkM8RY__"